import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 13.334V2.667a.667.667 0 0 1 1.334 0v10.667a.667.667 0 0 1-1.334 0M12.666 13.334V2.667a.667.667 0 0 1 1.334 0v10.667a.667.667 0 0 1-1.334 0M9.333 5.333a.666.666 0 0 0-.666-.666H7.333a.666.666 0 0 0-.666.666v5.334a.666.666 0 0 0 .666.666h1.334a.666.666 0 0 0 .666-.666zm1.334 5.334a2 2 0 0 1-2 2H7.333a2 2 0 0 1-2-2V5.333a2 2 0 0 1 2-2h1.334a2 2 0 0 1 2 2z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })